import {
  LEAK_STATUS,
  CONNECTIVITY_STATUS,
  BATTERY_STATUS,
  APP_STATUS
} from './deviceStatus'

// APP STATUS
export const APP_LABEL = {
  [APP_STATUS.INSTALLED]: 'Registered',
  [APP_STATUS.WAITING_ON_PIPE]: 'Waiting On Pipe',
  [APP_STATUS.ON_PIPE]: 'On Pipe',
  [APP_STATUS.HIGH_USAGE]: 'High Usage',
  [APP_STATUS.LEAK_INACTIVE]: 'Leak Free',
  [APP_STATUS.LEAK_ACTIVE]: 'Low-flow Leak',
  [APP_STATUS.LOW_SIGNAL]: 'Low Signal',
  [APP_STATUS.NO_SIGNAL]: 'No Signal',
  [APP_STATUS.ENGINEER_REPAIRED]: 'Repaired by Engineer',
  [APP_STATUS.CUST_REPAIRED]: 'Repaired by Customer',
  [APP_STATUS.ENG_VISIT]: 'Eng Visit Booked',
  [APP_STATUS.ENG_VISIT_NO_LEAK]: 'No Leak - Eng Visit Booked',
  [APP_STATUS.FITTING_ERROR]: 'Fitting Error'
}

// LEAK
export const LEAK_LABEL = {
  [LEAK_STATUS.NULL]: 'Uknown',
  [LEAK_STATUS.LEAK]: 'Leak',
  [LEAK_STATUS.NO_LEAK]: 'No Leak',
  [LEAK_STATUS.ENG_VISIT_NO_LEAK]: 'No Leak - Engineer Visit Booked',
  [LEAK_STATUS.LEAK_ENG_VISIT]: 'Leak - Engineer Visit Booked',
  [LEAK_STATUS.REPAIRED]: 'Repaired by Engineer',
  [LEAK_STATUS.CUST_REPAIRED]: 'Repaired by Customer',
  [LEAK_STATUS.CUST_REPAIRED_FAILED]: 'Customer Repair Failed',
  [LEAK_STATUS.FAILED_REPAIR]: 'Engineer Repair Failed',
  [LEAK_STATUS.UNKNOWN_NO_SIG]: 'Unknown - No Signal',
  [LEAK_STATUS.UNKNOWN_LOST_SIG]: 'Unknown - Lost Signal',
  [LEAK_STATUS.UNKOWN]: 'Unknown',
  [LEAK_STATUS.SUSPECT]: 'Leak Suspected'
}

// CONNECTIVITY
export const CONNECTIVITY_LABEL = {
  [CONNECTIVITY_STATUS.NULL]: 'Unknown',
  [CONNECTIVITY_STATUS.NO_SIGNAL]: 'No Signal',
  [CONNECTIVITY_STATUS.HAS_SIGNAL]: 'Has Signal',
  [CONNECTIVITY_STATUS.LOW_SIGNAL]: 'Low Signal',
  [CONNECTIVITY_STATUS.LOST_SIGNAL]: 'Lost Signal'
}

// BATTERY
export const BATTERY_LABEL = {
  [BATTERY_STATUS.NULL]: 'Unknown',
  [BATTERY_STATUS.GOOD_BATTERY]: 'Good',
  [BATTERY_STATUS.LOW_BATTERY]: 'Low',
  [BATTERY_STATUS.NO_BATTERY]: 'Low - Lost Signal',
  [BATTERY_STATUS.NO_SIGNAL]: 'Low - No Signal'
}
